import { viewPdfFile, downloadPdfFile, mergePdfFiles } from './pdf';
import { PDFDocument } from 'pdf-lib';
import pdfMake from "pdfmake/build/pdfmake.min";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { contractTemplate } from './contract-config';
import { IMerchant, IMerchantDetails } from 'src/common/types';
import { Offer } from 'src/context/offer-context';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const vodalendMerchantAgreementStatic = require('../assets/pdf/BCA Terms & Conditions.pdf');
const vodalendMerchantAgreementStaticFinal = require('../assets/pdf/BCA Merchant Agreement final.pdf');
const contractPdfFileName = 'business cash advance contract.pdf';
const base64PdfPrefix = 'data:application/pdf;base64,';

export const getContractPdfBase64 = async (
  merchantDetails: IMerchantDetails,
  merchant: IMerchant,
  selectedOffer: Offer,
  termsOnly?: boolean,
) => termsOnly ? getContractStaticRemainderPagesBytes(true).then((pdfBytes) => PDFDocument.load(pdfBytes).then((pdfDocument) => pdfDocument.saveAsBase64())) :
    Promise.all([
      getContractDynamicCoverPageBytes(merchantDetails, merchant, selectedOffer),
      getContractStaticRemainderPagesBytes(),
    ])
      .then(([coverPageBytes, remainderPagesBytes]) =>
        mergePdfFiles([coverPageBytes, remainderPagesBytes]),
      )
      .then((mergedPdfBytes) => PDFDocument.load(mergedPdfBytes))
      .then((pdfDocument) => pdfDocument.saveAsBase64());

export const downloadContractPdf = async (
  merchantDetails: IMerchantDetails,
  merchant: IMerchant,
  selectedOffer: Offer,
) =>
  await getContractPdfBase64(merchantDetails, merchant, selectedOffer).then((pdfBase64) =>
    downloadPdfFile(base64PdfPrefix + pdfBase64, contractPdfFileName),
  );

export const viewContractPdf = async (
  merchantDetails: IMerchantDetails,
  merchant: IMerchant,
  selectedOffer: Offer,
  termsOnly?: boolean,
) =>
  await getContractPdfBase64(merchantDetails, merchant, selectedOffer, termsOnly).then((pdfBase64) =>
    viewPdfFile(base64PdfPrefix + pdfBase64, contractPdfFileName),
  );

const getBase64 = (pdfDocGenerator): Promise<string> => {
  return new Promise((resolve, reject) => {
    try {
      pdfDocGenerator.getBase64((data) => {
        resolve(data);
      });
    } catch (error) {
      reject(error);
    }
  });
};

const getContractDynamicCoverPageBytes = async (
  merchantDetails: IMerchantDetails,
  merchant: IMerchant,
  selectedOffer: Offer,
) => {
  const documentDefinition = contractTemplate(merchantDetails, merchant, selectedOffer);
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  return getBase64(pdfDocGenerator);
};

export const getContractStaticRemainderPagesBytes = async (termsOnly?: boolean) =>
  fetch(termsOnly ? vodalendMerchantAgreementStatic : vodalendMerchantAgreementStaticFinal).then((res) => res.arrayBuffer());
